import React, { Component, Suspense } from "react"
import { Container, Col, Button, Row } from "reactstrap"
import { withTranslation } from 'react-i18next'
import { Redirect } from 'react-router-dom'
import { CSSTransition } from "react-transition-group";
import character_2 from "../images/characters/character_2.png"


import i18n from 'i18next'

import NahibuHelmet from "../components/nahibu-helmet"
import { LazyLoadImage } from 'react-lazy-load-image-component'
import axios from "axios"

import kitBiobakeryConsultRG from "../images/details/kit-consult.png"
import consultingReport from "../images/details/consultation-rapport.png"
import kitWhite from "../images/details/kit-white.png"
import tickNahibu from "../images/details/tick-nahibu.png"
import ReportBiobakeryRG_FR from "../images/details/reportBiobakeryRG_FR.png"
import ReportBiobakeryRG_EN from "../images/details/reportBiobakeryRG_EN.png"
import kitBiobakeryRG from "../images/details/kit_biobakery_rg.png"
import kitBiobakeryRGReport from "../images/details/kit_biobakery_rg.png"
import AvisClient from "../components/kits-details/avis-client.jsx"

import kitOpen from "../images/expert/kit-3D-accessoires.png"



import Utils from "../classes/utils"
import AvisVideo from "../components/kits-details/avis-video.jsx"
import AvisVideoExpert from "../components/kits-details/avis-expert.jsx"
import RecevoirResultats from "../components/kits-details/recevoir-resultats.jsx"
import AnalyseMicrobiote from "../components/kits-details/analyse-microbiote.jsx"
import KitTechnologie from "../components/kits-details/kit-technologie.jsx"
import FormFAQProduct from "../components/home/form-FAQ-product.jsx"
import Reassurance from "../components/home/reassurance-blue.jsx"

import Flag from "react-world-flags";
import { FaCheckCircle, FaCreditCard, FaTruck, FaBullseye, FaBrain, FaUserMd, FaAngleDoubleRight, FaAngleDown, FaPhoneAlt } from "react-icons/fa";

const WaitingDiv = React.lazy(() => import('../components/waiting'));


class KitDetails extends Component {

  constructor(props) {
    super(props);

    const t = this.props.t;
    const language = i18n.language ? (i18n.language.startsWith("fr") ? "fr" : i18n.language.startsWith("en") ? "en" : 'es') : undefined;
    this.langSubPath = language === "en" ? "/en" : language === "es" ? "/es" : "";
    this.productUrlMap = {
      1: `${this.langSubPath}/${t("path|details-produit")}/kit-nahibu`,
      2: `${this.langSubPath}/${t("path|details-produit")}/kit-nahibu-expert`,
      9: `${this.langSubPath}/${t("path|details-produit")}/consultation`,
    };





    this.state = {
      redirect: null,
      redirectState: {},
      productImage: 0,
      emailForm: null,
      withConsultation: false,
      openCharacteristics: {},
      quantity: 1,
    }

    this.utils = new Utils()
    this.handleClick = this.handleClick.bind(this)
    this.changeProductImage = this.changeProductImage.bind(this);




  }
  /* Permet de gérer la quantité du produit */
  handleQuantityChange(amount) {
    this.setState((prevState) => {
      const newQuantity = Math.max(1, Math.min(99, prevState.quantity + amount))
      return {
        quantity: newQuantity
      };
    });
  }
  /* Permet de récupérer l'image du rapport en fonction de la langue */
  getReportImage() {
    const language = i18n.language
      ? i18n.language.toLowerCase().startsWith("fr")
        ? "fr"
        : "en" // pour "en" et "es", on met EN
      : "en";

    return language === "fr" ? ReportBiobakeryRG_FR : ReportBiobakeryRG_EN;
  }
  /* Permet de basculer l'état d'ouverture des caractéristiques */
  toggleCharacteristic(index) {
    this.setState((prevState) => ({
      openCharacteristics: {
        ...prevState.openCharacteristics,
        [index]: !prevState.openCharacteristics[index],
      }
    }));
  }

  /* Permet d'ajouter un produit au panier et de rediriger vers la page du panier */
  addItemToCart(event, quantity, coupon) {
    if (!quantity || quantity < 1) quantity = 1;
    const t = this.props.t;


    let products = []
    let kit_consult_skus = this.props.config.products.kit_biobakery_rg_consult.skus

    const selectedProductSku = event.target.getAttribute('sku')

    if (kit_consult_skus.includes(selectedProductSku)) {
      products = [
        {
          productSkus: this.props.config.products.kit_biobakery_rg.skus[0],
          quantity: quantity,
        },
        {
          productSkus: this.props.config.products.consultation_solo.skus[0],
          quantity: quantity,
        },
      ]
    } else {
      products = [
        {
          productSkus: selectedProductSku,
          quantity: quantity,
        },
      ]
    }

    // Redirect to cart
    this.setState({
      redirect: this.langSubPath + "/" + t("path|panier") + "/",
      redirectState: {
        products: products,
        coupon: coupon,
      }
    })
  }
  /* Permet de changer l'image du produit affichée */
  changeProductImage(index) {
    this.setState({ productImage: index });
  }

  /* Permet de récupérer les lignes des caractéristiques du produit */
  getLines(characteristic) {
    return characteristic.line.map((line, index) => {
      return <li className="mb-1 small font-weight-light">{line}</li>

    })
  }
  /* Permet de récupérer les caractéristiques du produit */
  getCharacteristics(product) {
    return product.characteristic.map((characteristic, index) => {
      const isReportPreview = characteristic.title === this.props.t("product|Aperçu de la première page du rapport");
      const isOpen = this.state.openCharacteristics[index];

      return (
        <div key={index} className="mb-3">
          <p
            className="mb-1 ml-n2 d-flex justify-content-between align-items-center"
            style={{ cursor: "pointer" }}
            onClick={
              isReportPreview
                ? () => { this.goToReportImage(); this.backToTop(); }
                : () => this.toggleCharacteristic(index)
            }
          >
            <span className="">
              <LazyLoadImage width="7%" className="mb-1" src={tickNahibu} /> {characteristic.title}
            </span>
            {!isReportPreview && (
              <span
                style={{
                  transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
                  transition: "transform 0.3s",
                }}
              >
                <FaAngleDown className="fix-icon-pad" />
              </span>
            )}
          </p>

          {!isReportPreview && (
            <CSSTransition
              in={isOpen}
              timeout={300}
              classNames="accordion"
              unmountOnExit
            >
              <ul className="check-bullet ml-4">
                {this.getLines(characteristic)}
              </ul>
            </CSSTransition>
          )}
        </div>
      );
    });
  }

  /* Permet de rediriger vers l'image du rapport */
  goToReportImage() {
    const product = this.products.find((p) => p.id === 1); // ou selon comment tu récupères le produit actuel

    if (product) {
      const reportImageIndex = product.images.findIndex(img => img === this.getReportImage());
      if (reportImageIndex !== -1) {
        this.setState({ productImage: reportImageIndex });
      }
    }
  }



  /* Permet de récupérer les images du produit */
  getImages(product) {
    return product.images.map((image, index) => {
      return (
        <Button onClick={() => this.changeProductImage(index)} className="bg-light border-0 rounded hover-product mt-2 my-0 my-md-1 mr-2 mr-md-0 mt-md-0" >
          <LazyLoadImage className="" alt={product.subtitle} src={image} width='100%' />
        </Button>
      )
    })
  }
  /* Permet de remonter en haut de la page */
  backToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }

  /* Permet de gérer le clic sur le bouton "Ajouter au panier" */
  handleClick(event, quantity, coupon) {
    this.addItemToCart(event, quantity, coupon)

    if (this.props.auth.logged) {
      const data = {
        email: this.props.auth.user.email,
        sendinblue_list: "Abandon panier"
      }

      const requestUrl = this.props.config.wooApiUrl + "/register-list"
      axios.post(requestUrl, data).then(response => {
        this.setState({
          email: "",
          success: true,
          error: false,
          waiting: false,
        })
      }).catch(error => {
        // manage errors
        if (error.response) {
          console.error("Response error", error.response.data.data.message)
        } else if (error.request) {
          console.error("Request error", error.request)
        } else {
          console.error("Error", error.message)
        }

        this.setState({
          success: false,
          error: true,
          waiting: false,
        })
      })
      event.preventDefault()
    }

  }

  render() {
    const t = this.props.t

    this.products = [
      {
        id: 1,
        rupture: false,
        name: t("product|Kit Nahibu"),
        meta_title: t("product|Analyse Microbiote Intestinal : Kit Test Complet à Domicile"),
        meta_description: t("product|Analysez votre microbiote intestinal chez vous avec le kit Nahibu. Résultats détaillés, conseils adaptés, analyse 100 % française."),
        subtitle: t("product|Test du microbiote intestinal"),
        description: t("product|Ballonnements, fatigue, inconfort ? Le test Nahibu révèle ce que votre digestion ne vous dit pas... et vous aide à reprendre le contrôle."),
        price: 199.00,
        sku: this.props.config.products.kit_biobakery_rg.skus[0],
        images: [
          kitBiobakeryRG, kitOpen, kitWhite, this.getReportImage()
        ],
        infos: [
          { icon: <FaCheckCircle className="fix-icon-pad" />, text: t("nos-produits|Recommandé par les professionnels du bien-être") },
          { icon: <FaCreditCard className="fix-icon-pad" />, text: t("nos-produits|Payez en 3 échéances de 66,33€ sans frais") },
          { icon: <FaTruck className="fix-icon-pad" />, text: t("nos-produits|Livraison et retour du kit gratuits (France uniquement)") },
          { icon: <Flag code="FR" alt="FR" className="fix-icon-pad" />, text: t("nos-produits|100% Français") },
        ],
        characteristic: [
          {
            title: t("product|Ce que comprend votre kit Nahibu"),
            line: [
              t("product|Analyse complète de votre microbiote intestinal"),
              t("product|Lien entre digestion et bien-être mental"),
              t("product|Identification des bactéries clés"),
              t("product|Étude des fonctions métaboliques"),
              t("product|Rapport visuel et facile à lire"),
              t("product|Plan nutritionnel personnalisé"),
              t("product|Aperçu immédiat de votre rapport inclus"),
              t("product|Tableau des taxons"),
            ]
          },
          {
            title: t("product|Un plan alimentaire selon votre microbiote"),
            line: [
              t("product|+200 aliments adaptés à votre microbiote"),
              t("product|Mangez selon votre flore intestinale."),
              t("product|Votre microbiote vous parle, votre assiette s’adapte"),
            ]
          },
          {
            title: t("product|Aperçu de la première page du rapport"),
            line: [
            ]
          },
        ]
      },
      {
        id: 2,
        rupture: false,
        name: t("product|Kit Nahibu Expert"),
        meta_title: t("product|Analyse Microbiote Intestinal : Kit Test Complet à Domicile"),
        meta_description: t("product|Bilan complet du microbiote intestinal, nutrition personnalisée et consultation avec un expert Nahibu pour vous aider à améliorer votre bien-être."),
        subtitle: t("product|Test du microbiote intestinal + Consultation"),
        description: t("product|Ballonnements, fatigue, inconfort ? Le test Nahibu révèle ce que votre digestion ne vous dit pas... et vous aide à reprendre le contrôle."),
        price: 249.00,
        sku: this.props.config.products.kit_biobakery_rg_consult.skus[0],
        images: [
          kitBiobakeryConsultRG, kitOpen, kitWhite, this.getReportImage()
        ],
        infos: [
          { icon: <FaCheckCircle className="fix-icon-pad" />, text: t("nos-produits|Recommandé par les professionnels du bien-être") },
          { icon: <FaCreditCard className="fix-icon-pad" />, text: t("nos-produits|Payez en 3 échéances de 83,00€ sans frais") },
          { icon: <FaTruck className="fix-icon-pad" />, text: t("nos-produits|Livraison et retour du kit gratuits (France uniquement)") },
          { icon: <Flag code="FR" alt="FR" className="fix-icon-pad" />, text: t("nos-produits|100% Français") },
        ],
        characteristic: [
          {
            title: t("product|Ce que comprend votre kit Nahibu"),
            line: [
              t("product|Analyse complète de votre microbiote intestinal"),
              t("product|Lien entre digestion et bien-être mental"),
              t("product|Identification des bactéries clés"),
              t("product|Étude des fonctions métaboliques"),
              t("product|Rapport visuel et facile à lire"),
              t("product|Plan nutritionnel personnalisé"),
              t("product|Aperçu immédiat de votre rapport inclus"),
              t("product|Tableau des taxons"),
            ]
          },
          {
            title: t("product|Un plan alimentaire selon votre microbiote"),
            line: [
              t("product|+200 aliments adaptés à votre microbiote"),
              t("product|Mangez selon votre flore intestinale."),
              t("product|Votre microbiote vous parle, votre assiette s’adapte"),
            ]
          },
          {
            title: t("product|Consultation avec un expert"),
            line: [
              t("product|30 minutes de téléconsultation"),
              t("product|Compréhension de vos résultats"),
              t("product|Réponse à vos questions sur l'analyse")
            ]
          },
          {
            title: t("product|Aperçu de la première page du rapport"),
            line: []
          },
        ]
      },
      {
        id: 9,
        rupture: false,
        name: t("product|Consultation"),
        meta_title: t("product|Consultation avec un expert"),
        meta_description: t("product|Consultez un expert Nahibu après votre analyse du microbiote pour vous aider à comprendre vos résultats et améliorer votre bien-être."),
        subtitle: t("product|Consultation avec un expert"),
        description: t("product|Explication des résultats du rapport Nahibu avec un expert du microbiote."),
        price: 50.00,
        sku: this.props.config.products.consultation_solo.skus[0],
        images: [
          consultingReport,
          kitBiobakeryRGReport
        ],

        infos: [
          { icon: <FaUserMd className="fix-icon-pad" />, text: t("nos-produits|Entretien personnalisé de 30 minutes") },
          { icon: <FaBrain className="fix-icon-pad" />, text: t("nos-produits|Compréhension claire de vos résultats") },
          { icon: <FaBullseye className="fix-icon-pad" />, text: t("nos-produits|Conseils concrets et adaptés à votre profil") },
          { icon: <Flag code="FR" alt="FR" className="fix-icon-pad" />, text: t("nos-produits|100% Français") },
        ],
        characteristic: [
          {
            title: t("product|Consultation avec un expert"),
            line: [
              t("product|30 minutes de téléconsultation"),
              t("product|Compréhension de vos résultats"),
              t("product|Réponse à vos questions sur l'analyse")
            ]
          },
        ]
      }
    ]




    if (this.state.redirect) {
      return <Redirect to={{
        pathname: this.state.redirect,
        state: this.state.redirectState,
      }} />
    }

    const path = this.props.location.pathname;

    let product;
    if (path.includes("/consultation")) {
      product = this.products.find((p) => p.id === 9);
    } else if (this.state.withConsultation) {
      product = this.products.find((p) => p.id === 2);
    } else {
      product = this.products.find((p) => p.id === 1);
    }



    if (!product) {
      return <Redirect to="/" />;
    }

    if (this.props.waitingStore) {
      return (<Suspense fallback={<div></div>}><WaitingDiv center={true} waiting={this.props.waitingStore} /></Suspense>)
    }
    return (


      <div id="top">
        <NahibuHelmet
          canonicalUrl={'https://nahibu.me' + this.langSubPath + '/' + t('canonical-url|details-produit') + '/'}
          title={product.meta_title + " | Nahibu"}
          description={product.meta_description}
        />


        <Container id="top" className="my-md-3 my-2 py-5">
          <Row>


            <Col md={0} xs={12} className="d-md-none d-xs-flex flex-column">
              <h1 className="h2-override-2 mb-3 dark-blue">{product.name}<LazyLoadImage className="ml-3" alt={t("buy|Kit d'analyse du microbiote intestinal Nahibu")} src={character_2} width="28px" /></h1>
              {product.id !== 9 && (
                <h2 className="h3-override mb-2 dark-blue">{product.subtitle}</h2>
              )}
              <p className="font-weight-light dark-blue small mb-1 mt-0">{product.description}</p>
              {/* Consultation option */}
              {product.id !== 9 && (
                <div className="consultation-choice mb-4">
                  <div
                    className={`consultation-card mb-2 p-3 border rounded ${this.state.withConsultation ? "selected" : ""}`}
                    onClick={() => this.setState({ withConsultation: true })}
                    style={{ cursor: "pointer" }}
                  >
                    <div className="d-flex align-items-center mb-2 dark-blue">
                      <FaPhoneAlt className="icon-fix-small" style={{ paddingBottom: "2px" }} />
                      <strong className="ml-2">{t("product|Consultation")}</strong>
                    </div>
                    <hr className="my-2" />
                    <p className="mb-2 font-weight-light dark-blue small">
                      {t("product|Une consultation avec un expert du microbiote est vivement recommandée pour comprendre vos résultats et agir concrètement sur votre bien-être.")}
                    </p>
                    <div className="text-right font-weight-bold">+ 50,00 €</div>
                  </div>
                  <div className={`consultation-card p-3 border dark-blue rounded ${!this.state.withConsultation ? "selected" : ""}`} onClick={() => this.setState({ withConsultation: false })}>
                    <strong>{t("product|Pas de Consultation")}</strong>
                  </div>
                </div>
              )}


              <div className="px-1 font-weight-light dark-blue">
                {product.infos.map((info, i) => (
                  <p key={i} className="dark-blue mt-0 mb-1 d-flex align-items-center small">
                    {React.cloneElement(info.icon, { className: "mr-2 icon-fix-small" })}
                    {info.text}
                  </p>
                ))}
              </div>



              <div className="px-4 mt-3 font-weight-light dark-blue">
                {[...this.getCharacteristics(product)]}
              </div>
              {product.id >= 5 && product.id < 9 ?
                <p className="mt-3 font-weight-light dark-blue">{t("product|Une boîte de 30 gélules pour des premiers effets, 3 boîtes de 30 gélules pour une complémentation optimale.")}</p>
                : <></>}
              <div className="d-flex justify-content-center w-100">
                <div className="mt-auto w-75 nav-link pl-0 pr-0 py-0">
                  <div className="d-flex align-items-center justify-content-center mb-3">
                    <Button size="sm" onClick={() => this.handleQuantityChange(-1)} className="btn-quantity">-</Button>
                    <span className="mx-3 dark-blue">{this.state.quantity}</span>
                    <Button size="sm" onClick={() => this.handleQuantityChange(1)} className="btn-quantity">+</Button>
                  </div>
                  <Button onClick={(e) => product.coupon_probioform ? this.handleClick(e, this.state.quantity, product.coupon_probioform) : this.handleClick(e, this.state.quantity, null)} sku={product.sku} className="font-weight-light btn-pricing-slider w-100 d-flex justify-content-between btn-hover mb-4">

                    <div
                      role="button"
                      onClick={(e) => product.coupon_probioform ? this.handleClick(e, this.state.quantity, product.coupon_probioform) : this.handleClick(e, this.state.quantity, null)}
                      sku={product.sku}>
                      <FaAngleDoubleRight className="pr-2 icon-fix-small fix-icon-pad" />{t("product|Ajouter au panier")}
                    </div>
                    <div
                      role="button"
                      onClick={(e) => product.coupon_probioform ? this.handleClick(e, this.state.quantity, product.coupon_probioform) : this.handleClick(e, this.state.quantity, null)}
                      sku={product.sku}>
                      {product.coupon_probioform && product.couponValue ?
                        <span sku={product.sku}>
                          <del sku={product.sku}>
                            {(product.price * this.state.quantity).toFixed(2) + "€"}
                          </del>&nbsp;&nbsp;
                          <b sku={product.sku}>
                            {((product.price * this.state.quantity) - Math.abs(product.couponValue)).toFixed(2)}€
                          </b>
                        </span>
                        : <span sku={product.sku}>
                          {(product.price * this.state.quantity).toFixed(2) + "€"}
                        </span>
                      }
                      {product.secondPrice ?
                        <span
                          onClick={(e) => product.coupon_probioform ? this.handleClick(e, this.state.quantity, product.coupon_probioform) : this.handleClick(e, this.state.quantity, null)}
                          sku={product.sku} className="small">
                          /{t("product|mois ou ")} {(product.secondPrice).toFixed(2)}€
                        </span>

                        : <></>}
                    </div>
                  </Button>
                </div>
              </div>
            </Col>
            <Col md={7} xs={12} className="my-auto" >
              <Row>
                <Col md={2} className="my-auto order-2 order-md-1">
                  {[...this.getImages(product)]}
                </Col>
                <Col md={10} className="order-1 order-md-2 w-100">
                  <div className="bg-light rounded w-100" >
                    <LazyLoadImage className="rounded" alt={t("product|Analyse Microbiote Intestinal : Kit Test Complet à Domicile")} src={product.images[this.state.productImage]} width='100%' />
                  </div>
                </Col>
              </Row>
              <AnalyseMicrobiote />
              <KitTechnologie />
              <RecevoirResultats />
              <AvisClient />
              <AvisVideo />
              <AvisVideoExpert />
              <FormFAQProduct />
              <Reassurance />
            </Col>

            <Col md={5} xs={0} className="d-none d-md-flex flex-column sticky-sidebar">
              <h1 className="h2-override-2 dark-blue">{product.name}<LazyLoadImage className="ml-3" alt={t("buy|Kit d'analyse du microbiote intestinal Nahibu")} src={character_2} width="28px" /></h1>
              {product.id !== 9 && (
                <h2 className="h3-override mb-2 dark-blue">{product.subtitle}</h2>
              )}
              <p className="font-weight-light dark-blue small mb-1 mt-0">{product.description}</p>
              {/* Consultation option */}
              {product.id !== 9 && (
                <div className="consultation-choice mb-4">
                  <div
                    className={`consultation-card mb-2 p-3 border rounded ${this.state.withConsultation ? "selected" : ""}`}
                    onClick={() => this.setState({ withConsultation: true })}
                    style={{ cursor: "pointer" }}
                  >
                    <div className="d-flex align-items-center mb-2 dark-blue">
                      <FaPhoneAlt className="icon-fix-small" style={{ paddingBottom: "2px" }} />
                      <strong className="ml-2">{t("product|Consultation")}</strong>
                    </div>
                    <hr className="my-2" />
                    <p className="mb-2 font-weight-light dark-blue small">
                      {t("product|Une consultation avec un expert du microbiote est vivement recommandée pour comprendre vos résultats et agir concrètement sur votre bien-être.")}
                    </p>
                    <div className="text-right font-weight-bold">+ 50,00 €</div>
                  </div>
                  <div
                    className={`consultation-card p-3 border dark-blue rounded ${!this.state.withConsultation ? "selected" : ""}`}
                    onClick={() => this.setState({ withConsultation: false })}
                    style={{ cursor: "pointer" }}
                  >
                    <strong>{t("product|Pas de Consultation")}</strong>
                  </div>
                </div>
              )}


              <div className="px-1 font-weight-light dark-blue">
                {product.infos.map((info, i) => (
                  <p key={i} className="dark-blue mt-0 mb-1 d-flex align-items-center small">
                    {React.cloneElement(info.icon, { className: "mr-2 icon-fix-small" })}
                    {info.text}
                  </p>
                ))}
              </div>



              <div className="px-4 mt-3 font-weight-light dark-blue">
                {[...this.getCharacteristics(product)]}
              </div>
              {product.id >= 5 && product.id < 9 ?
                <p className="mt-3 font-weight-light dark-blue">{t("product|Une boîte de 30 gélules pour des premiers effets, 3 boîtes de 30 gélules pour une complémentation optimale.")}</p>
                : <></>}
              <div className="d-flex justify-content-center w-100">
                <div className="mt-auto w-75 nav-link pl-0 pr-0 py-0">
                  <div className="d-flex align-items-center justify-content-center mb-3">
                    <Button size="sm" onClick={() => this.handleQuantityChange(-1)} className="btn-quantity">-</Button>
                    <span className="mx-3 dark-blue">{this.state.quantity}</span>
                    <Button size="sm" onClick={() => this.handleQuantityChange(1)} className="btn-quantity">+</Button>
                  </div>

                  <Button onClick={(e) => product.coupon_probioform ? this.handleClick(e, this.state.quantity, product.coupon_probioform) : this.handleClick(e, this.state.quantity, null)} sku={product.sku} className="font-weight-light btn-pricing-slider-2 white-hover w-100 d-flex justify-content-between btn-hover mb-4">

                    <div
                      role="button"
                      onClick={(e) => product.coupon_probioform ? this.handleClick(e, this.state.quantity, product.coupon_probioform) : this.handleClick(e, this.state.quantity, null)}
                      sku={product.sku}>
                      <FaAngleDoubleRight className="pr-2 icon-fix-small fix-icon-pad" />{t("product|Ajouter au panier")}
                    </div>
                    <div
                      role="button"
                      onClick={(e) => product.coupon_probioform ? this.handleClick(e, this.state.quantity, product.coupon_probioform) : this.handleClick(e, this.state.quantity, null)}
                      sku={product.sku}>
                      {product.coupon_probioform && product.couponValue ?
                        <span sku={product.sku}>
                          <del sku={product.sku}>
                            {(product.price * this.state.quantity).toFixed(2) + "€"}
                          </del>&nbsp;&nbsp;
                          <b sku={product.sku}>
                            {((product.price * this.state.quantity) - Math.abs(product.couponValue)).toFixed(2)}€
                          </b>
                        </span>
                        : <span sku={product.sku}>
                          {(product.price * this.state.quantity).toFixed(2) + "€"}
                        </span>
                      }
                      {product.secondPrice ?
                        <span
                          onClick={(e) => product.coupon_probioform ? this.handleClick(e, this.state.quantity, product.coupon_probioform) : this.handleClick(e, this.state.quantity, null)}
                          sku={product.sku} className="small">
                          /{t("product|mois ou ")} {(product.secondPrice).toFixed(2)}€
                        </span>

                        : <></>}
                    </div>
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
        {/* Bouton CTA mobile sticky */}
        <div className="sticky-footer-cta d-md-none px-3 py-4 bg-white border-top gradiant-bot-gray pl-4">
          <Row className="align-items-center w-100">
            {/* Colonne : Sélecteur de quantité */}
            <Col xs="3" className="d-flex align-items-center justify-content-start">
              <Button size="sm" onClick={() => this.handleQuantityChange(-1)} className="btn-quantity-phone">-</Button>
              <span className="mx-2 dark-blue">{this.state.quantity}</span>
              <Button size="sm" onClick={() => this.handleQuantityChange(1)} className="btn-quantity-phone">+</Button>
            </Col>
            <Col xs="3" className="d-flex justify-content-start">
              <div
                role="button"
                className="pl-3"
                onClick={(e) => product.coupon_probioform ? this.handleClick(e, this.state.quantity, product.coupon_probioform) : this.handleClick(e, this.state.quantity, null)}
                sku={product.sku}>
                {product.coupon_probioform && product.couponValue ?
                  <span sku={product.sku}>
                    <del sku={product.sku}>
                      {(product.price * this.state.quantity).toFixed(2) + "€"}
                    </del>&nbsp;&nbsp;
                    <b sku={product.sku}>
                      {((product.price * this.state.quantity) - Math.abs(product.couponValue)).toFixed(2)}€
                    </b>
                  </span>
                  : <span sku={product.sku}>
                    {(product.price * this.state.quantity).toFixed(2) + "€"}
                  </span>
                }
                {product.secondPrice ?
                  <span
                    onClick={(e) => product.coupon_probioform ? this.handleClick(e, this.state.quantity, product.coupon_probioform) : this.handleClick(e, this.state.quantity, null)}
                    sku={product.sku} className="small">
                    /{t("product|mois ou ")} {(product.secondPrice).toFixed(2)}€
                  </span>

                  : <></>}
              </div>
            </Col>

            {/* Colonne : Bouton commander */}
            <Col xs="6" className="d-flex justify-content-end pl-4">
              <Button
                onClick={(e) =>
                  product.coupon_probioform
                    ? this.handleClick(e, this.state.quantity, product.coupon_probioform)
                    : this.handleClick(e, this.state.quantity, null)
                }
                sku={product.sku}
                className="font-weight-light btn-pricing-slider btn-hover small"
              >

                <FaAngleDoubleRight className="fix-icon-pad small" size={15} />
                {t("nos-produits|Commander mon kit")}
              </Button>
            </Col>
          </Row>
        </div>

      </div>
    )
  }
}
export default withTranslation()(KitDetails)
